import React, { useState } from "react";
import Select from "react-select";
import { IconButton, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Pagination from '../utils/Pagination';
import '../styles/responsive.css';

function FornecedorTabela ({vetor, selecionar,filtrar,vetrores}){
const [nomeEmpresa, setNomeEmpresa] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;

 // Gerando as opções para o Select
 const options = Array.from(
    new Set(vetrores.map((obj) => obj.nomeEmpresa ))
).map((nomeEmpresa) => ({
    value: nomeEmpresa,
    label: nomeEmpresa,
    
}));

// Função para atualizar a descrição quando o usuário selecionar uma opção
const handleSelectChange = (selectedOption) => {
    setNomeEmpresa(selectedOption ? selectedOption.value : "");
    setCurrentPage(1); // Reset para primeira página quando filtrar
};

// Função de busca, que filtra a lista de matérias-primas com base na descrição
const handleBuscar = () => {
    filtrar(nomeEmpresa);
    setCurrentPage(1); // Reset para primeira página quando buscar
};

// Cálculos de paginação
const totalItems = vetor.length;
const totalPages = Math.ceil(totalItems / itemsPerPage);
const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
const currentItems = vetor.slice(startIndex, endIndex);

// Função para mudar de página
const handlePageChange = (page) => {
    setCurrentPage(page);
};

    return(
        <div>
            <Box className="search-container toolbar-inline" sx={{ mb: 2 }}>
                <Select
                    value={options.find(option => option.value === nomeEmpresa) || null}
                    onChange={handleSelectChange}
                    options={options}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="Pesquisa Nome Empresa"
                    className="fixed-select"
                />
                <button
                    onClick={handleBuscar}
                    className="btn btn-primary btn-sm"
                >
                    Busca
                </button>
            </Box>

            <div className="table-responsive-container">
                <table className="table table-responsive table-mobile table-compact">
                    <thead>
                        <tr>
                            <th className="col-id">Código</th>
                            <th className="col-nome">Nome</th>
                            <th className="col-cnpj">CNPJ</th>
                            <th className="col-telefone">Telefone</th>
                            <th className="col-email">Email</th>
                            <th className="col-endereco">Endereço</th>
                            <th className="col-acoes">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(currentItems) && currentItems.map((obj) => (
                            <tr key={obj.id}>
                                <td className="col-id" data-label="Código">{obj.id}</td>
                                <td className="col-nome text-ellipsis" title={obj.nomeEmpresa} data-label="Nome">{obj.nomeEmpresa}</td>
                                <td className="col-cnpj" data-label="CNPJ">{obj.cnpj}</td>
                                <td className="col-telefone" data-label="Telefone">{obj.telefone}</td>
                                <td className="col-email text-ellipsis" title={obj.email} data-label="Email">{obj.email}</td>
                                <td className="col-endereco text-ellipsis" title={obj.endereco} data-label="Endereço">{obj.endereco}</td>
                                <td className="col-acoes" data-label="Ações">
                                    <IconButton
                                        size="small"
                                        onClick={(event)=>{selecionar(obj.id,event)}}
                                        color="primary"
                                    >
                                        <EditIcon />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                startIndex={startIndex}
                endIndex={endIndex}
            />
        </div>
    );

}

export default FornecedorTabela;